import './style.scss';

import { FC, useMemo } from 'react';
import { parseCoreUser } from 'services/utils/user-utils';
import { Client, Stylist } from 'types/user';

type ProfilePhotoProps = {
    user: Client | Stylist | any;
    level?: boolean;
    className?: string;
};

const ProfilePhoto: FC<ProfilePhotoProps> = ({ user, level = false, className = '' }) => {
    const { initials, fullName } = useMemo(
        () => parseCoreUser(user),
        [user]
    );

    return (
        <div className={`profile-photo ${className} ${level ? user?.level : ''}`}>
            {(user?.picture_small || user?.profile_picture) && (
                <img src={user.picture_small || user.profile_picture} alt={fullName} />
            )}
            {initials}
        </div>
    );
};

export default ProfilePhoto;
